module.exports = __webpack_public_path__ + "static/media/checkmark-circle-green-big.8eb4a7ca.svg";